module.exports = __webpack_public_path__ + "img/business-startup.c06bcae7.png";